// /src/components/SubscribeNewsModal.jsx
import React from "react";
import { useTranslation } from "react-i18next";

export default function SubscribeNewsModal({
  open,
  onClose,
  email,
  onEmailChange,
  submitting = false,
  errorMessage = "",
  onSubmit,
}) {
  const { t } = useTranslation("common");
  if (!open) return null;

  const canSubmit = email.trim().length > 3 && !submitting;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "min(92vw, 560px)",
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 12px 32px rgba(0,0,0,.25)",
          overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            background: "#00723a",
            color: "#fff",
            padding: "16px 22px",
            fontWeight: 800,
            fontSize: 20,
            letterSpacing: ".3px",
          }}
        >
          {t("modals.subscribe_news.title", "Підписка на новини")}
        </div>

        <div style={{ padding: "20px 22px 22px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
            <input
              type="email"
              placeholder={t("modals.subscribe_news.email_placeholder", "Ваша email адреса")}
              value={email}
              onChange={(e) => onEmailChange?.(e.target.value)}
              required
              autoFocus
              style={{
                flex: 1,
                padding: "12px 16px",
                fontSize: 16,
                borderRadius: 8,
                border: "1px solid #bbb",
              }}
            />
          </div>

          {/* Резерв под статус/ошибку — чтобы модалка не дёргалась */}
          <div
            style={{
              minHeight: 22,
              marginBottom: 8,
              display: "flex",
              alignItems: "center",
            }}
          >
            {submitting ? (
              <div style={{ color: "#888" }}>
                {t("modals.subscribe_news.sending", "Надсилаємо лист підтвердження…")}
              </div>
            ) : errorMessage ? (
              <div style={{ color: "#e54848" }}>{errorMessage}</div>
            ) : null}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
            <button
              onClick={onClose}
              disabled={submitting}
              style={{
                padding: "10px 18px",
                fontSize: 16,
                borderRadius: 8,
                border: "1px solid #ddd",
                background: "#fff",
                cursor: submitting ? "not-allowed" : "pointer",
                opacity: submitting ? 0.6 : 1,
              }}
            >
              {t("common.cancel", "Скасувати")}
            </button>
            <button
              onClick={onSubmit}
              disabled={!canSubmit}
              style={{
                padding: "10px 18px",
                fontSize: 16,
                borderRadius: 8,
                border: "none",
                background: "#00723a",
                color: "#fff",
                fontWeight: 700,
                opacity: canSubmit ? 1 : 0.6,
                cursor: canSubmit ? "pointer" : "not-allowed",
              }}
            >
              {t("modals.subscribe_news.cta", "Підписатися")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
